﻿import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';

import { ButtonProps } from 'components/GMetrixDialogConfirm/GMetrixDialogConfirm';

import 'components/GMetrixDialogPrompt/gmetrix-dialog-prompt.scss';

import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';

const GMetrixDialogPrompt = forwardRef((props, forwardRef) => {

    const [showModal, setShowModal] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<any>();
    const [promptMessage, setPromptMessage] = useState<string>('');
    const [title, setTitle] = useState<string>('Notice');
    const [promptButtonProps, setPromptButtonProps] = useState<ButtonProps>({ variant: 'primary' });
    const resolveRef = useRef(null);
    const resolve: any = resolveRef?.current;

    const createPrompt = (title: string, message: string, promptButtonProps: ButtonProps, startingValue?: any) => new Promise(resolve => {

        (resolveRef.current as any) = resolve;

        setShowModal(true);
        setInputValue(startingValue);
        setPromptMessage(message);
        setTitle(title);
        if (promptButtonProps){

            setPromptButtonProps(promptButtonProps);

        }

    });

    const closeSuccessfulDialog = () => {

        setShowModal(false);
        resolve(inputValue);
        setInputValue(undefined);

    };

    const closeDialog = () => {

        setShowModal(false);
        resolve(null);
        setInputValue(undefined);

    };

    useImperativeHandle(forwardRef, () => ({
        prompt: createPrompt
    }), []);

    return (
        <Modal onHide={closeDialog} show={showModal}>
            {

                <Modal.Header closeButton>
                    <Modal.Title>
                        {title}
                    </Modal.Title>
                </Modal.Header>

            }
            <Modal.Body >
                {promptMessage}
                <GMetrixInput
                    onChange={e => {

                        setInputValue(e.target.value);

                    }}
                    value={inputValue}
                />
            </Modal.Body>
            <Modal.Footer>

                <GMetrixButton
                    className={`btn btn-sm`}
                    onClick={closeDialog}
                    style={{ minWidth: 82 }}
                    type='button'
                    variant='secondary'
                >
                    <FormattedMessage defaultMessage="Cancel" id="cancel.89a86adc" />
                </GMetrixButton>
                <GMetrixButton
                    className={`btn btn-sm`}
                    iconClass={promptButtonProps.iconClass}
                    onClick={closeSuccessfulDialog}
                    style={{ minWidth: 82 }}
                    type='button'
                    variant={promptButtonProps.variant}
                >
                    {promptButtonProps.buttonText ?? <FormattedMessage defaultMessage="Confirm" id="confirm.297ab8f4" />}
                </GMetrixButton>

            </Modal.Footer>
        </Modal>
    );

});
GMetrixDialogPrompt.displayName = 'GMetrixDialogPrompt';
export default GMetrixDialogPrompt;